import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useDropboxFiles } from '../../hooks/useDropboxFiles';
import FolderSelector from '../Common/FolderSelector';

interface MoveFileModalProps {
  file: any;
  onClose: () => void;
  onSuccess: () => void;
}

const MoveFileModal: React.FC<MoveFileModalProps> = ({ file, onClose, onSuccess }) => {
  const [selectedFolderId, setSelectedFolderId] = useState<string | null>(file.folder_id);
  const { moveFileTo, loading } = useDropboxFiles();

  const handleMove = async () => {
    const result = await moveFileTo(file.id, selectedFolderId);
    if (result) {
      onSuccess();
      onClose();
    }
  };

  return (
    <Modal show={true} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Move File</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Move{' '}
          <strong 
            style={{ 
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              hyphens: 'auto'
            }}
            title={file.name}
          >
            {file.name}
          </strong>{' '}
          to:
        </p>
        <FolderSelector
          value={selectedFolderId}
          onChange={setSelectedFolderId}
          disabled={loading}
          label="Destination Folder"
          placeholder="Search or select destination folder..."
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleMove} disabled={loading}>
          {loading ? 'Moving...' : 'Move'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MoveFileModal;
